import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgCameraSelectedNavIconSecondary from './svgs/CameraSelectedNavIconSecondary.js';
import SvgCameraSelectedNavIcon from './svgs/CameraSelectedNavIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var cameraSelectedNavIcon = (props => useIcon(SvgCameraSelectedNavIcon, SvgCameraSelectedNavIconSecondary, props));

export { cameraSelectedNavIcon as default };
